import { createClient } from '@supabase/supabase-js'
const supabaseUrl = 'https://twxreqrjauhvewvpfojf.supabase.co'
const supabaseKey = 'sb_publishable_RUwYiUgwQcsD_E99GBrcEg_GYurAwUu'
export const supabase = createClient(supabaseUrl, supabaseKey)